import { BridgePosition } from '../../app/types';
import { GameEngine, convertIntToBridgePosition } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { getClaimNotificationConfig } from '../../utils/shark-helper';
import { useTranslation } from 'react-i18next';
import React from 'react';

export function MID_CLAIM_NOTIFICATION(cmdObj: SFSObject, sender: GameEngine) {
    //North visible if handVisibility & 2 != 0, East & 4, South & 8, West &16
    sender.setHandsFromScore(cmdObj, true, 'hand');
    const tricks: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);
    const seat: number = cmdObj.getInt(SFSVAR.SFSGAME_SEAT_ID);
    const player: BridgePosition = convertIntToBridgePosition(seat);
    sender.setHandVisibility(31);
    const { t } = useTranslation();
  //  const claimNotificationConfig = getClaimNotificationConfig(convertIntToBridgePosition(seat), tricks)
    sender.props.table_setAuxiliaryMessage({
        position: 'left',
        message: {
            text: t('modal.claim.notification.body', {
                bridgePosition: `${player[0].toUpperCase() + player.substr(1).toLowerCase()}`,
                claim: `${tricks}`
            } || {}),
            buttonAuxiliary: undefined,
            buttonOk: undefined,
            buttonCancel: undefined,
            titleColor: undefined,
        },
    });

    //sender.clientResponseClaim('approve');
}

export function MID_CLAIM_NOTIFICATION_SB(cmdObj: SFSObject, sender: GameEngine) {
    // this.setHandsFromState(cmdObj);
    // const tricks: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);
    // const seat: number = cmdObj.getInt(SFSVAR.SFSGAME_SEAT_ID);
    // this.setHandVisibility(31);
    // this.showModal(getClaimNotificationConfig(convertIntToBridgePosition(seat), tricks));
}
